import React from 'react'
import ClickOutHandler from 'react-onclickout'
import TextInputField from 'components/Form/TextInputField'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'
import './styles.scss'
import Nixi1Spinner from 'components/Nixi1Spinner'

export const TagSelector = ({
  isOpen,
  setIsOpen, 
  hasCreateCategoryOption = false,
  allCategories,
  searchCategory,
  onCategoryClick,
  selectedCategories,
  isLoading = false,
  forPoolFilter = false
}) => {
  const history = useHistory()
  
  if (isOpen) {
    return (
      <ClickOutHandler onClickOut={() => setIsOpen(false)}>
        <div className={`tag-selector__list ${forPoolFilter && 'tag-selector__list--for-pool-filter'} animated fadeIn`}>
          <div className='tag-selector__search-container'>
            <div className='tag-selector__search'>
              <TextInputField
                name='search'
                id='search'
                className='tag-selector__search__input'
                onChange={value => searchCategory(value)}
                placeholder={I18n.t('dashboard_search')}
                autoFocus
              />
            </div>
            <div className='tag-selector__close' onClick={() => setIsOpen(false)}>
              <i className='fa fa-close'></i>
            </div>
          </div>
          {
            hasCreateCategoryOption && (
              <div
                className='tag-selector__create-category'
                onClick={() => history.push('/dashboard/configurations/categories')}
              >
                <i className='fa fa-plus'></i>
                <span>{I18n.t('dashboard_new_label')}</span>
              </div>

            )
          }
          {
            isLoading ? (
              <div className='tag-selector__loading-container'>
                <Nixi1Spinner width='24px' height='24px' />
              </div>
            ) : (
              <>
                {allCategories.length > 0 && allCategories.map(currentCategory => {
                  return (
                    <div
                      key={currentCategory.category}
                      className='tag-selector__category-item animated fadeIn'
                      style={{ 'backgroundColor': currentCategory.color ? currentCategory.color : '#f9f6f6', color: currentCategory.color ? 'white' : 'black' }}
                      onClick={() => onCategoryClick(currentCategory)}
                    >
                      <span>{currentCategory.name}</span>
                      {
                        Array.isArray(selectedCategories) ? 
                          selectedCategories.includes(currentCategory.category) ? 
                            <i className="fa fa-check"></i> :
                            <i className='fa fa-plus tag-selector__category-item__add animated fadeIn'></i>
                          : <i className='fa fa-plus tag-selector__category-item__add animated fadeIn'></i>
                      }
                    </div>
                  )
                })}
              </>
            )
          }
        </div>
      </ClickOutHandler>
    )
  }
  return null
}
export default TagSelector